export default {
  auth: {
    login_title: 'Selamat Datang!',
    login: 'Masuk',
    register_title: 'Buat Akun',
    register: 'Daftar',
    forgot_password: 'Lupa password',
    no_account: 'Belum punya akun',
    forgot_password_desc: 'Masukan alamat email Anda lalu Kami akan mengirimkan instruksi perubahan password',
    enter_email: 'Masukan Email',
    reset_password: 'Buat Password Baru',
  },
  header: {
    profile: 'Profil',
    logout: 'Keluar'
  },
  form: {
    validation: {
      required: '{field} tidak boleh kosong',
      email: '{field} tidak valid',
      min_length: '{field} harus minimal {length} karakter.',
      max_length: '{field} maksimal {length} karakter.',
      min_value: '{field} harus sama dengan atau lebih besar dari {label}.',
      digit: '{field} harus {length} digit',
      password_confirmation: 'konfirmasi password tidak sama.',
      password_strength: 'Password harus mengandung kombinasi huruf besar, huruf kecil, angka dan karakter khusus.'
    },
    button: {
      submit: 'Kirim',
      yes: 'Ya',
      no: 'Tidak',
      cancel: 'Batal',
      back: 'Kembali',
      save: 'Simpan'
    },
    placeholder: {
      enter_email: 'Masukan Email',
      select_industry: 'Silahkan pilih industri',
      select_province: 'Silahkan pilih provinsi',
      select_province_first: 'Silahkan pilih provinsi terlebih dahulu',
      select_city: 'Silahkan pilih kota'
    },
    field: {
      new_password: 'Password Baru',
      confirm_password: 'Konfirmasi Password',
      name: 'Nama',
      phone: 'Telepon',
      address: 'Alamat',
      industry: 'Industri',
      province: 'Provinsi',
      city: 'Kota',
      postal_code: 'Kode Pos',
      personal_contact: 'Kontak Personal',
    }
  }
}